/*
  Yfact - l'abbonamento e' la scelta preselezionata (07/09/2026).

  Perche' esiste. Il prezzo che si vede deve essere quello del percorso
  consigliato, l'abbonamento (CONTESTO.md, capitolo 4, "Come si mostra il
  prezzo"). Il widget di Shopify Subscriptions parte sempre da "Acquisto
  singolo" e non legge il parametro ?selling_plan= dell'URL. Il Liquid del
  tema lo legge solo se accanto c'e' anche ?variant= (provato il 07/09/2026:
  i link delle card portano entrambi, cosi' il prezzo giusto esce gia' dal
  server, e questo script lo conferma un istante dopo). Quindi:

  1. al caricamento della scheda si seleziona il primo piano di abbonamento
     nel widget - a meno che l'URL non porti selling_plan=0, che e' il modo
     per aprire la scheda sull'acquisto singolo;
  2. a ogni cambio di piano i prezzi del tema si riscrivono con i numeri che
     il widget stesso dichiara nei suoi radio (data-variant-price,
     data-variant-compare-at-price): quando e' scelto un piano, prezzo del
     piano grande, listino barrato accanto, e la riga "al mese, in
     abbonamento"; quando e' scelto l'acquisto singolo, il listino e basta.
     I prezzi sono due: quello del blocco prodotto (.product-info__price) e
     quello della barra fissa in fondo alla pagina (product-quick-add), che
     Impact rifa' da capo a ogni cambio di variante. Un MutationObserver
     riapplica il piano ogni volta che uno dei due viene ridisegnato.

  Cosa tocca. Solo il widget dell'app (i suoi radio, riconosciuti da
  data-radio-type) e i due contenitori del prezzo. Il markup del widget non
  e' del tema: se Shopify lo cambia, e' questo file da aggiornare, non il
  resto. La stringa "al mese, in abbonamento" arriva dal Liquid
  (window.yfactTesti, scritto in layout/theme.liquid) cosi' resta
  traducibile nei locali. Il prezzo del piano resta nel colore del testo,
  non in quello dei saldi: il barrato accanto dice gia' tutto.
*/
(function () {
  'use strict';

  var url = new URL(window.location.href);
  var testi = window.yfactTesti || {};

  function listePrezzo() {
    return Array.prototype.slice.call(document.querySelectorAll('.product-info__price price-list, product-quick-add price-list'));
  }

  function radioPiani() {
    return Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][data-radio-type="selling_plan"]'));
  }

  function radioScelto() {
    var tutti = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][data-radio-type]'));
    return tutti.filter(function (r) { return r.checked; })[0] || null;
  }

  function testoPrezzo(sale) {
    var copia = sale.cloneNode(true);
    var nascosto = copia.querySelector('.sr-only');
    if (nascosto) nascosto.remove();
    return copia.textContent.trim();
  }

  // Riscrive una lista prezzi dai dati del radio scelto. E' idempotente: se
  // la lista dice gia' la cosa giusta non tocca niente, cosi' l'observer che
  // la richiama non rimbalza sulle proprie modifiche.
  function aggiornaLista(lista, scelto) {
    var prezzo = scelto.getAttribute('data-variant-price') || '';
    var listino = scelto.getAttribute('data-variant-compare-at-price') || '';
    var piano = scelto.getAttribute('data-radio-type') === 'selling_plan' && listino !== '';
    var sale = lista.querySelector('sale-price');
    if (!sale || !prezzo) return;
    var compare = lista.querySelector('compare-at-price.yfact-barrato');
    var riga = lista.querySelector('.yfact-riga-piano');
    var giusto = testoPrezzo(sale) === prezzo && (piano ? (compare && riga) : (!compare && !riga));
    if (giusto) return;

    var etichetta = sale.querySelector('.sr-only');
    sale.textContent = '';
    if (etichetta) sale.appendChild(etichetta);
    sale.appendChild(document.createTextNode(prezzo));
    sale.classList.remove('text-on-sale');
    if (piano) {
      if (!compare) {
        compare = document.createElement('compare-at-price');
        compare.className = 'text-subdued line-through yfact-barrato';
        sale.insertAdjacentElement('afterend', compare);
      }
      compare.textContent = listino;
      if (!riga) {
        riga = document.createElement('span');
        riga.className = 'yfact-riga-piano text-subdued';
        lista.appendChild(riga);
      }
      riga.textContent = testi.mese || '';
    } else {
      if (compare) compare.remove();
      if (riga) riga.remove();
    }
  }

  function aggiornaPrezzo() {
    var scelto = radioScelto();
    if (!scelto) return;
    listePrezzo().forEach(function (lista) { aggiornaLista(lista, scelto); });
  }

  // 1. Preselezione. Il widget dell'app si disegna dopo il tema: si riprova
  //    per qualche secondo, poi si lascia perdere senza errori.
  function preseleziona(tentativo) {
    if (url.searchParams.get('selling_plan') === '0') return;
    var scelto = radioScelto();
    if (scelto && scelto.getAttribute('data-radio-type') === 'selling_plan') { aggiornaPrezzo(); return; }
    var candidato = radioPiani()[0];
    if (candidato) {
      candidato.click();
      if (!candidato.checked) candidato.checked = true;
      candidato.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(aggiornaPrezzo, 50);
      return;
    }
    if (tentativo < 24) setTimeout(function () { preseleziona(tentativo + 1); }, 250);
  }

  // 2. Il prezzo segue ogni cambio nel widget.
  document.addEventListener('change', function (evento) {
    var el = evento.target;
    if (el instanceof HTMLInputElement && el.type === 'radio' && el.hasAttribute('data-radio-type')) {
      setTimeout(aggiornaPrezzo, 30);
    }
  }, true);

  // 3. Impact ridisegna il blocco prodotto e la barra fissa (product-rerender)
  //    dopo un cambio di variante: il piano va riapplicato al nuovo markup.
  var attesa = null;
  var osservatore = new MutationObserver(function () {
    if (attesa) return;
    attesa = setTimeout(function () { attesa = null; aggiornaPrezzo(); }, 60);
  });

  function avvia() {
    osservatore.observe(document.body, { childList: true, subtree: true });
    preseleziona(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
